// App version - the human "release" number. Bump manually for meaningful releases.
export const APP_VERSION = "1.0.2";

// Short git SHA of the deployed build, injected at build time by CI as
// REACT_APP_BUILD (see .github/workflows/*.yml). Empty in local dev. Shown next
// to APP_VERSION in the nav so colleagues can confirm they're on the same
// deployed build even when a stale browser cache is serving them an old bundle.
export const APP_BUILD = (process.env.REACT_APP_BUILD || "").slice(0, 7);
